// extracted by mini-css-extract-plugin
module.exports = {"container":"FailToUseSocialLogin_container__1C_ae","msg":"FailToUseSocialLogin_msg__2lh9y","btn":"FailToUseSocialLogin_btn__3d9ob"};